import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../constants';

export const useServiceModalStyles = makeStyles((theme) => ({
  addFormColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  deleteConfirmActions: {
    marginTop: theme.spacing(1),
  },
  deleteConfirmBox: {
    backgroundColor: '#fff3f0',
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dialogSubtitle: {
    color: COLORS.muted,
    marginTop: theme.spacing(0.5),
  },
  editActions: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}));
